import React, { useEffect } from 'react';
import { initMetaPixelWithPageView } from '../utils/metaPixel';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { AudienceSection } from '../components/AudienceSection';
import { ProcessSection } from '../components/ProcessSection';
import { FaqSection } from '../components/FaqSection';
import { BonusSection } from '../components/BonusSection';
import { OfferSection } from '../components/OfferSection';
import { Footer } from '../components/Footer';
export function TaxRescuePage() {
  useEffect(() => {
    initMetaPixelWithPageView();
  }, []);
  return <main className="w-full min-h-screen bg-midnight-950 font-body" data-id="element-480">
      <HeroSection data-id="element-481" />
      <ProblemSection data-id="element-482" />
      <SolutionSection data-id="element-483" />
      <AudienceSection data-id="element-484" />
      <ProcessSection data-id="element-485" />
      <FaqSection data-id="element-486" />
      <BonusSection data-id="element-487" />
      <OfferSection data-id="element-488" />
      <Footer data-id="element-489" />
    </main>;
}